import { MessageResponse } from '@acme/api';
import { SupportChatProps } from '@acme/domains';

export interface Attachment {
  id?: string;
  url?: string;
  fileName?: string | null;
  size?: string;
}

export interface Message extends MessageResponse {
  id?: string;
  text?: string | null;
  sentAt?: string;
  readAt?: string | null;
  isAnswer?: boolean;
  attachments?: Array<Attachment> | null;
}

export interface ChatState {
  messages: Message[];
  isLoading: boolean;
  isLoadingMore: boolean;
  hasMoreMessages: boolean;
  currentPage: number;
  totalPages: number | null;
  totalCount: number | null;
  hasNewMessages: boolean;
  error: string | null;
}

export interface ChatConfig {
  chatId: string;
  pageSize?: number;
  loadHistory: SupportChatProps['loadChatHistory'];
}

export interface ChatWindowApi {
  companionLabelText?: string;
  loadChatHistory: SupportChatProps['loadChatHistory'];
  sendMessage: SupportChatProps['sendMessage'];
  getAttachmentReq: SupportChatProps['getAttachmentReq'];
}

export const initialChatState: ChatState = {
  messages: [],
  isLoading: false,
  isLoadingMore: false,
  hasMoreMessages: true,
  currentPage: 1,
  totalPages: null,
  totalCount: null,
  hasNewMessages: false,
  error: null,
};
